export const calculateServicesSpentMoney = (serviceRequests) => {
  const services = serviceRequests.map(request => {
    const paymentCost = parseFloat(request.paymentCost) || 0;
    const oneOffCost = parseFloat(request.oneOffCost) || 0;
    const subscriptionCost = parseFloat(request.subscriptionCost) || 0;

    return paymentCost || oneOffCost || subscriptionCost || 0;
  });

  const totalCost = services.reduce((acc, cost) => acc + cost, 0);

  return totalCost;
}
